import LegalPageLayout from "@/components/legal/LegalPageLayout";
import { mentionsLegalesContent } from "@/data/legal/mentionsLegalesContent";

export default function MentionsLegalesPage() {
  return <LegalPageLayout content={mentionsLegalesContent} testId="mentions-legales-page" />;
}
